module.exports = __webpack_public_path__ + "ddc006cd35f8958300ac96542e7b5479.pdf";